<div class="row">
    <div class="col-12">
        <h4 class="mb-2 py-1 font-header-1">Lov</h4>
    </div>
</div>

<div class="row mb-2 mt-2">
    <div class="col ">
        <div widget class="card border-0 box-shadow">
            <!-- <div class="card-header transparent  text-muted">
               
            </div> -->
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row d-flex justify-content-center align-items-center lov-1">
                    <div class="col-lg-4 col-md-4 col-sm-4 lov1">
                        <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal"
                            [disabled]="selectListType==null || selectListType==undefined || selectListType==''"
                            data-bs-target="#Createmodal" (click)="CreateorUpdateLov('CreatelovModal')" 
                            *ngIf="fp.lovcreate">Add
                            Lov</button>
                    </div>
                    <div class="col-lg-4  col-md-4 col-sm-4  lov2">
                        <span class="row">
                            <span class="col-12">
                                <label >Select List</label>
                            </span>
                            <span class="col-12">
                        <ng-select class="w-100" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="selectListType" (change)="getLovFilter()" style="color: black;"
                            [clearable]="true" [searchable]="true" [items]="getListDropdownList" bindLabel="listName"
                            bindValue="id">
                        </ng-select>
                    </span>
                </span>
                    </div>
                    <div class="col-lg-4  col-md-4 col-sm-4  lov3">
                        <button type="button" class="btn blue-btn btn-sm text-right" (click)="clearLov('refresh')">
                            <i class="fa fa-repeat"> Refresh </i>
                        </button>
                    </div>
                </div>
                <!-- ejs-grid -->
                <div class="row mt-2" style="min-height: 500px;">
                    <div class="col pt-2">
                        <ejs-grid #gridLov [dataSource]='GridList | async' [allowPaging]='true' [pageSettings]='initialPage'
                        [filterSettings]='filterSettings' [allowFiltering]='true' [allowResizing]='true'
                        (dataStateChange)='dataChangeLov($event)'
                        [showColumnChooser]='true'
                    (actionBegin)="onActionLov($event)" 
                        [allowSorting]='true'>
                        <e-columns>
                            <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                <ng-template #template let-data>
                                    <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#Createmodal"
                                        (click)="CreateorUpdateLov('UpdatelovModal');getDetails(data)" 
                                        *ngIf="fp.lovupdate"><i
                                            class="fa fa-edit"></i></button>&nbsp;
                                    <button class="btn btn-delete-table" data-bs-toggle="modal"
                                        data-bs-target="#deleteLovmodal" (click)="getDetails(data)" 
                                        *ngIf="fp.lovdelete"><i
                                            class="fa fa-trash"></i></button>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="lovCode" headerText="Lov Code" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
    
                            <e-column minWidth=100 field="lovName" headerText="Lov Name" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
    
                            <e-column minWidth=100 field="lovValue" headerText="Lov Value" type="string">
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                            <e-column minWidth=100 field="isRequired" headerText="Required" type="string" [allowFiltering]='false'>
                                <ng-template #template let-data>
                                    {{ data.isRequired ? 'Yes' : 'No' }}
                                </ng-template>
                            </e-column>
    
                            <e-column width="50" [showInColumnChooser]='false'>
                                <ng-template #headerTemplate let-data>
                                    <div>
                                        <span id='show' (click)='showLovColumns()'><i class="fa fa-cog fa-lg"
                                                aria-hidden="true">
                                            </i></span>
                                    </div>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>


<!-- For Create or Update Modal -->
<span id="openLovModal" data-bs-toggle="modal" data-bs-target="#Createmodal"></span>
<div class="modal fade" id="Createmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="LovType == 'CreatelovModal'">
                        Create
                        Lov</span>
                    <span *ngIf="LovType == 'UpdatelovModal'">Update Lov</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="LovForm">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>LovCode<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="LovCode" class="form-control"
                                [(ngModel)]="saveLov.lovCode" />
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>LovName<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="LovName" class="form-control"
                                [(ngModel)]="saveLov.lovName" />
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>LovValue
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="LovValue" class="form-control"
                                [(ngModel)]="saveLov.lovValue" />
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Orderby<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="number" formControlName="Orderby" class="form-control"
                                [(ngModel)]="saveLov.orderby" />
                        </div>
                    </div>
                    <div class="row mt-1" *ngIf="isdocname">
                        <div class="col-lg-5">
                            <label >Required</label>
                        </div>
                        <div class="col-lg-7">
                            <input type="checkbox" formControlName="isRequired" [(ngModel)]="saveLov.isRequired" />
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateLov();" [disabled]="!LovForm.valid ||isSaveorUpdateBoolean"><span
                        *ngIf="LovType == 'CreatelovModal'"> Save &
                        Close</span> <span *ngIf="LovType == 'UpdatelovModal'">Update & Close</span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearLov('cancel')">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeLovModal" data-bs-target="#deleteLovmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteLovmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearLov('cancel')"
                    aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteLov()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="clearLov('cancel')">No</button>
            </div>
        </div>
    </div>
</div>

  
   
